import { motion } from 'framer-motion';
import sam7 from '../../assets/sam7.webp'; 
import styles from './IntroStudioSection.module.css';

const IntroStudioSection = () => {
  return (
    <section className={styles.section}>
      <div className={styles.contentWrapper}>
        <div className={styles.textContainer}>
          <div className={styles.circleWrapper}>
            <motion.svg 
                viewBox="0 0 100 100" 
                className={styles.circleText}
                animate={{ rotate: 360 }}
                transition={{
                    duration: 10,
                    ease: 'linear',
                    repeat: Infinity,
                }}
            >
              <defs>
                <path
                  id="circlePath"
                  d="M50,50 m-35,0 a35,35 0 1,1 70,0 a35,35 0 1,1 -70,0"
                />
              </defs>
              <text>
                <textPath
                  href="#circlePath"
                  startOffset="0"
                  textLength="190"
                  className={styles.textPath}
                >
                  WELCOME TO MY JOURNEY
                </textPath>
              </text>
            </motion.svg>
          </div>

          <h2 className={styles.heading}>
            actress. artist. <br />
            always evolving.
          </h2>

          <p className={styles.paragraph}>
            Hey! I’m Samantha Olguin, but you can call me Sam. I am a singer-songwriter, actress, and techie. I am so many things wrapped into one human, and I wouldn’t have it any other way! I’m currently super excited about my acting projects. Click below to see my past and current projects.
          </p>

          <a 
            href="https://www.imdb.com/name/nm8413138/"
            target="_blank"
            rel="noopener noreferrer"
            className={styles.button}>
            Learn More
          </a>
        </div>

        <div className={styles.imageContainer}>
          <img src={sam7} alt="Sam Headshot" className={styles.image} />
        </div>
      </div>
    </section>
  );
};

export default IntroStudioSection;
